document.addEventListener('DOMContentLoaded', function() {
  console.log('Quick View: Script loaded');
  
  // Create modal HTML and append to body
  const modalHTML = `
    <div id="quick-view-modal" class="quick-view-modal">
      <div class="quick-view-overlay"></div>
      <div class="quick-view-content">
        <button class="quick-view-close" aria-label="Close Quick View">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        <div class="quick-view-body">
          <div class="quick-view-loading">
            <div class="spinner"></div>
          </div>
        </div>
      </div>
    </div>
  `;
  
  document.body.insertAdjacentHTML('beforeend', modalHTML);
  console.log('Quick View: Modal added to page');
  
  const modal = document.getElementById('quick-view-modal');
  const modalBody = modal.querySelector('.quick-view-body');
  const closeBtn = modal.querySelector('.quick-view-close');
  const overlay = modal.querySelector('.quick-view-overlay');
  
  // Handle quick view button clicks - using mousedown instead of click
  document.addEventListener('mousedown', function(e) {
    const quickViewBtn = e.target.closest('.quick-view-button');
    if (quickViewBtn) {
      console.log('Quick View: Button clicked');
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      const productHandle = quickViewBtn.getAttribute('data-product-handle');
      console.log('Quick View: Product handle:', productHandle);
      
      // Force hide the product card quick buy area
      const productCard = quickViewBtn.closest('.product-card__figure');
      if (productCard) {
        const quickBuySection = productCard.querySelector('.product-card__quick-buy');
        if (quickBuySection) {
          quickBuySection.style.opacity = '0';
          quickBuySection.style.pointerEvents = 'none';
        }
      }
      
      openQuickView(productHandle);
    }
  }, true); // Use capture phase
  
  // Also try with click event
  document.addEventListener('click', function(e) {
    const quickViewBtn = e.target.closest('.quick-view-button');
    if (quickViewBtn) {
      console.log('Quick View: Click event triggered');
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      const productHandle = quickViewBtn.getAttribute('data-product-handle');
      if (productHandle) {
        openQuickView(productHandle);
      }
    }
  }, true);
  
  // Close modal
  function closeModal() {
    console.log('Quick View: Closing modal');
    modal.classList.remove('active');
    document.body.style.overflow = '';
    
    // Reset all quick buy buttons visibility
    document.querySelectorAll('.product-card__quick-buy').forEach(qb => {
      qb.style.opacity = '';
      qb.style.pointerEvents = '';
    });
  }
  
  if (closeBtn) {
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeModal();
    });
  }
  
  if (overlay) {
    overlay.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeModal();
    });
  }
  
  // Close on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });
  
  // Open quick view
  function openQuickView(productHandle) {
    console.log('Quick View: Opening for product:', productHandle);
    
    if (!productHandle) {
      console.error('Quick View: No product handle provided');
      return;
    }
    
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    // Show loading state
    modalBody.innerHTML = `
      <div class="quick-view-loading">
        <div class="spinner"></div>
        <p style="margin-top: 20px; color: #666;">Loading product...</p>
      </div>
    `;
    
    // Fetch product data using Shopify's product JSON endpoint
    const productUrl = `/products/${productHandle}.js`;
    console.log('Quick View: Fetching from:', productUrl);
    
    fetch(productUrl)
      .then(response => {
        console.log('Quick View: Response status:', response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(product => {
        console.log('Quick View: Product data loaded:', product);
        console.log('Quick View: Number of images:', product.images ? product.images.length : 0);
        console.log('Quick View: Images array:', product.images);
        displayProductInfo(product);
      })
      .catch(error => {
        console.error('Quick View: Error loading product:', error);
        modalBody.innerHTML = `
          <div class="quick-view-error">
            <p>Sorry, we couldn't load this product.</p>
            <p style="font-size: 12px; color: #999; margin-top: 10px;">Error: ${error.message}</p>
            <p style="font-size: 12px; color: #999;">Product handle: ${productHandle}</p>
            <button onclick="document.getElementById('quick-view-modal').classList.remove('active'); document.body.style.overflow = '';" style="margin-top: 20px; padding: 10px 20px; background: #000; color: #fff; border: none; border-radius: 5px; cursor: pointer;">Close</button>
          </div>
        `;
      });
  }
  
  // Display product information
  function displayProductInfo(product) {
    console.log('Quick View: Displaying product info');
    
    const price = formatMoney(product.price);
    const comparePrice = product.compare_at_price && product.compare_at_price > product.price ? formatMoney(product.compare_at_price) : null;
    const image = product.featured_image || '';
    
    let priceHTML = `<span class="quick-view-price-current">${price}</span>`;
    if (comparePrice) {
      priceHTML = `
        <span class="quick-view-price-compare">${comparePrice}</span>
        <span class="quick-view-price-current quick-view-price-sale">${price}</span>
      `;
    }
    
    // Parse description
    let description = product.description || 'No description available.';
    
    modalBody.innerHTML = `
      <div class="quick-view-container">
        <div class="quick-view-image">
          ${image ? `<img src="${image}" alt="${product.title || 'Product image'}">` : '<div class="quick-view-no-image">No image available</div>'}
        </div>
        <div class="quick-view-info">
          ${product.vendor ? `<p class="quick-view-vendor">${product.vendor}</p>` : ''}
          <h2 class="quick-view-title">${product.title || 'Product'}</h2>
          <div class="quick-view-price">
            ${priceHTML}
          </div>
          <div class="quick-view-description">
            ${description}
          </div>
          <div class="quick-view-actions">
            <a href="/products/${product.handle}" class="quick-view-link button">View Full Details</a>
          </div>
        </div>
      </div>
    `;
    
    console.log('Quick View: Product info displayed successfully');
  }
  
  // Format money
  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = parseInt(cents);
    }
    if (isNaN(cents)) {
      return 'Rs.0.00';
    }
    const amount = (cents / 100).toFixed(2);
    return `Rs.${amount}`;
  }
  
  console.log('Quick View: All event listeners attached');
});